export const routeAdminOptions = [
  { value: "Buccal (Held inside of cheek)", label: "Buccal (Held inside of cheek)" },
  { value: "Enteral (Directly into stomach/PEG)", label: "Enteral (Directly into stomach/PEG)" },
  { value: "Infused (Injected into vein via IV drip)", label: "Infused (Injected into vein via IV drip)" },
  { value: "Inhalable (Breathed in via tube/mask)", label: "Inhalable (Breathed in via tube/mask)" },
  { value: "Inhaler (Breathed in through mouth)", label: "Inhaler (Breathed in through mouth)" },
  { value: "Intramuscular (Injected into muscle)", label: "Intramuscular (Injected into muscle)" },
  { value: "Intrathecal (Injected into spine)", label: "Intrathecal (Injected into spine)" },
  { value: "Intravenous (Injected into vein/IV line)", label: "Intravenous (Injected into vein/IV line)" },
  { value: "Nasal (Given via spray/pump)", label: "Nasal (Given via spray/pump)" },
  { value: "Nasogastric (Tube from nose to stomach)", label: "Nasogastric (Tube from nose to stomach)" },
  { value: "Ophthalmic (Eye drops/gel/ointment)", label: "Ophthalmic (Eye drops/gel/ointment)" },
  { value: "Oral (Swallowed: tablet/capsule/liquid)", label: "Oral (Swallowed: tablet/capsule/liquid)" },
  { value: "Oral (Mouthwash: swished and spit)", label: "Oral (Mouthwash: swished and spit)" },
  { value: "Oral (Toothpaste: used for teeth/gum)", label: "Oral (Toothpaste: used for teeth/gum)" },
  { value: "Otic (Drops into ear)", label: "Otic (Drops into ear)" },
  { value: "Rectal (Inserted into rectum)", label: "Rectal (Inserted into rectum)" },
  { value: "Subcutaneous (Injected under skin)", label: "Subcutaneous (Injected under skin)" },
  { value: "Sublingual (Held under tongue)", label: "Sublingual (Held under tongue)" },
  { value: "Topical (Applied to skin: patch, cream, shampoo)", label: "Topical (Applied to skin: patch, cream, shampoo)" },
  { value: "Transdermal (Given through skin patch)", label: "Transdermal (Given through skin patch)" },
  { value: "Vaginal (Inserted into vagina)", label: "Vaginal (Inserted into vagina)" },
];

export const medicationTypeOptions = [
  { value: "Buccal Tablet", label: "Buccal Tablet" },
  { value: "Capsules", label: "Capsules" },
  { value: "Cream", label: "Cream" },
  { value: "Drops", label: "Drops" },
  { value: "Granules", label: "Granules" },
  { value: "Inhalers", label: "Inhalers" },
  { value: "Injections (Intramuscular)", label: "Injections (Intramuscular)" },
  { value: "Injections (Intravenous)", label: "Injections (Intravenous)" },
  { value: "Injections (Subcutaneous)", label: "Injections (Subcutaneous)" },
  { value: "Liquid", label: "Liquid" },
  { value: "Mouthwash", label: "Mouthwash" },
  { value: "Patch", label: "Patch" },
  { value: "Powder", label: "Powder" },
  { value: "Pre-filled syringe", label: "Pre-filled syringe" },
  { value: "Sachet", label: "Sachet" },
  { value: "Suppositories", label: "Suppositories" },
  { value: "Tablet", label: "Tablet" },
  { value: "Toothpaste", label: "Toothpaste" },
  { value: "Topical medication (patch, cream, shampoo)", label: "Topical medication (patch, cream, shampoo)" },
  { value: "Nebuliser solution", label: "Nebuliser solution" },
];

export const howAssistedOptions = [
  { value: "NONE - self administered", label: "NONE - self administered" },
  { value: "Assisted (Prompt/Remind)", label: "Assisted (Prompt/Remind)" },
  { value: "Administered (Handed to client)", label: "Administered (Handed to client)" },
  { value: "Remind", label: "Remind" },
  { value: "Covert (Hidden in food/drink)", label: "Covert (Hidden in food/drink)" },
  { value: "Crushed", label: "Crushed" },
  { value: "Dispensed", label: "Dispensed" },
  { value: "Dissolved", label: "Dissolved" },
];

export const frequencyOptions = [
  { value: "Daily", label: "Daily" },
  { value: "OD (Once Daily)", label: "OD (Once Daily)" },
  { value: "BD (Twice Daily)", label: "BD (Twice Daily)" },
  { value: "TDS (Three Times Daily)", label: "TDS (Three Times Daily)" },
  { value: "QDS (Four Times Daily)", label: "QDS (Four Times Daily)" },
  { value: "Weekly", label: "Weekly" },
  { value: "Monthly", label: "Monthly" },
  { value: "As required (PRN)", label: "As required (PRN)" },
];

export const MedicationOptions = [
  { value: "Individual Medication", label: "Individual Medication" },
  { value: "Blister Pack", label: "Blister Pack" },
];